import React, { createContext, useMemo, useState } from 'react';
import type { FC, ReactNode } from 'react';

/**
 * @deprecated This type is deprecated and will be removed in a future version.
 * It was used to fetch comment count but is no longer needed as part of modernization.
 */
type pageCommentsCountContext = {
	count: number;
	setCount: (num: number) => void;
};

/**
 * @deprecated This context is deprecated and will be removed in a future version.
 * It was used to fetch comment count but is no longer needed as part of modernization.
 */
export const PageCommentsCountContext = createContext<pageCommentsCountContext>({
	count: 0,
	setCount: () => {},
});

type PageCommentsCountProviderProps = {
	children: ReactNode;
	contentId: string;
};

/**
 * @deprecated This provider is deprecated and will be removed in a future version.
 * It was used to fetch comment count but is no longer needed as part of modernization.
 */
export const PageCommentsCountProvider: FC<PageCommentsCountProviderProps> = ({
	children,
	contentId,
}) => {
	const [count, setCount] = useState(0);

	const pageCommentsCountContextValue = useMemo(
		() => ({
			count,
			setCount,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[count, contentId],
	);

	return (
		<PageCommentsCountContext.Provider value={pageCommentsCountContextValue}>
			{children}
		</PageCommentsCountContext.Provider>
	);
};
